import { FaExclamationTriangle, FaInfoCircle } from "react-icons/fa"

export default function ShipmentStatus ({ shipment }) {
  const {
    status_derived,
    status_details
  } = shipment

  const isActive = (status_derived !== 'Cancelled')
  const isException = (status_derived === 'Exception')
  const isOnHold = (status_derived === 'OnHold')
  const isDelivered = (status_derived === 'Delivered')

  const displayStatus = (
    isDelivered ? 'Delivered'
    : isException || !isActive ? status_derived
    : status_derived === 'InTransit' ? 'Shipped' 
    : status_derived
  )
  
  const filteredStatusDetails = status_details?.filter(sd => sd.name !== displayStatus)
  const hasStatusDetails = filteredStatusDetails?.length > 0

  return (
    <span style={{ color: '#565656', fontSize: '12px', fontStyle: 'italic', fontWeight: 'normal' }}>
      {(isException || isOnHold) &&
        <span style={{ cursor: 'help', marginRight: '3px', fontSize: '11px', position: 'relative', top: '1px' }}>
          {isException 
            ? <FaExclamationTriangle style={{ color: '#ef0c0c', marginRight: '3px' }} />
            : isOnHold
              ? <FaExclamationTriangle style={{ color: '#FEB800', marginRight: '3px' }} />
              : <></>
          }
        </span>
      }

      <span>{`${displayStatus}`}</span>

      {hasStatusDetails && <span>
        <span> - </span>
        {filteredStatusDetails?.map((sd,i) => 
          <span key={i}>
            <span title={sd.description} style={{ cursor: 'help' }}>
              {sd.name}
              <FaInfoCircle style={{ marginLeft: '3px', fontSize: '11px', position: 'relative', top: '1px' }} />
            </span>
            {i < filteredStatusDetails.length - 1 && <span>, </span>}
          </span>)
        }
      </span>}
    </span>
  )
}